import React, { useState } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar/Sidebardigital';

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');

  const sendOtp = async () => {
    try {
      const response = await axios.post('http://localhost:5002/send-otp', { phoneNumber });
      setMessage(response.data.message);
    } catch (error) {
      console.error('Error sending OTP:', error);
      setMessage('Failed to send OTP. Please try again later.');
    }
  };

  const verifyOtp = async () => {
    try {
      const response = await axios.post('http://localhost:5002/verify-otp', { phoneNumber, otp });
      setMessage(response.data.message);
      // Redirect user to dashboard upon successful login
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setMessage('Invalid OTP. Please try again.');
    }
  };


  return (
    <>
    <div className="row">
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
        <div className="col-8 custom-width"><br></br><br></br><br></br>
        <h2>Login</h2>  <br></br>
        <input
          type="text"
          placeholder="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <button onClick={sendOtp}>Send OTP</button>  <br></br><br></br>

        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />
        <button onClick={verifyOtp}>Verify OTP</button>
        </div>
      <p className="error-message">{message}</p>
      <br></br><br></br>
      <br></br><br></br>
      <br></br><br></br>
      </div>
    
    </>

  );
  };
export default Login;